import { render, staticRenderFns } from "./PatientDetailsForm.vue?vue&type=template&id=73738e57&scoped=true&"
import script from "./PatientDetailsForm.vue?vue&type=script&lang=js&"
export * from "./PatientDetailsForm.vue?vue&type=script&lang=js&"
import style0 from "./PatientDetailsForm.vue?vue&type=style&index=0&id=73738e57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73738e57",
  null
  
)

export default component.exports